import { useEffect, useState } from "react";

export function useIsMobile(bp = 800): boolean {
  const [is, setIs] = useState(() => window.innerWidth < bp);
  useEffect(() => {
    const on = () => setIs(window.innerWidth < bp);
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, [bp]);
  return is;
}
